@if (profileField$ | async; as profileField) {
    <sh-form-group
        [id]="profileField.FieldDefinition.FlatKey"
        [label]="profileField.DisplayLabel"
        [required]="profileField.Required"
        [helpText]="profileField.Description"
        [errorMsg]="(errorMsg$ | async) || '' | translate"
    >
        @if (isSupported) {
            @if (updatedFaceList().length === 0) {
                -
            }

            <!-- Indeterminate and MergeStrategy implementations are ommitted since we do not support them on this control -->
            <form [id]="profileField.DottedKey">
                @for (face of updatedFaceList(); track face.Id; let recordIndex = $index) {
                    <dl class="sh-description-list sh-clear-margin" style="flex-flow: row; width: 100%">
                        <sh-form-person-select
                            style="height: stretch"
                            [id]="profileField.FieldDefinition.FlatKey"
                            [label]="(childDefinitionLabel$ | async) + ' ' + (recordIndex + 1)"
                            [face]="face"
                            (faceChange)="updateFace($event)"
                            (faceDelete)="deleteFace($event)"
                        ></sh-form-person-select>
                    </dl>
                }
            </form>
        } @else {
            {{ "profile-form.errors.bulk-edit-unavailable" | translate: { type: profileField.DisplayLabel } }}
        }
    </sh-form-group>
}
